export default {
  showMoreLabel: {
    id: 'services_bouygues_offers_benefit_show_more',
    defaultMessage: 'More details',
  },
  showLessLabel: {
    id: 'services_bouygues_offers_benefit_show_less',
    defaultMessage: 'Less details',
  },
}
